import { render, staticRenderFns } from "./luckyCoinRank.vue?vue&type=template&id=17b74519&"
import script from "./luckyCoinRank.vue?vue&type=script&lang=js&"
export * from "./luckyCoinRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports